<template>
  <div class="group-management-container">
    <div class="menu-router-container">
      <third-router-nav />
    </div>
    <div v-loading="loading" class="menu-stores">
      <div class="stores-contain">
        <div class="simple-menu-box">
          <div class="simple-menu">
            <simple-search :search-data="searchData" :is-unwind="false" @child-event="getSearch" @child-close="getReset" />
          </div>
          <el-button type="primary" icon="el-icon-download" @click="getGoldenIdEaexportExcel()">
            下载
          </el-button>
        </div>
        <div class="user-table">
          <table-people
            :table-data="tableData"
            :table-headers="tableHeaders"
            :is-page="true"
            :border="false"
            :total="total"
            :page="current"
            :page-size="size"
            :page-sizes="[5, 10, 25, 50, 100]"
            :page-background="false"
            page-layout="total, sizes, prev, pager, next, jumper"
            page-position="right"
            @currentPage="currentPage"
            @sizeChange="sizeChange"
          >
            <template slot="companyList" slot-scope="scope">
              <p v-for="(item, index) in scope.row.companyList" :key="index">
                {{ item.companyName }}
              </p>
            </template>
            <template slot="publishStatus" slot-scope="scope">
              <span>{{ scope.row.publishStatus === 1 ? '未发布' : '已发布' }}</span>
            </template>
            <template slot="options" slot-scope="scope">
              <div class="operation">
                <div class="operation-btn" @click="goDetail(scope.row.id)">
                  详情
                </div>
                <!--                <div class="operation-btn edit-btn" @click="goEdit(scope.row.userId)">-->
                <!--                  编辑-->
                <!--                </div>-->
                <div class="operation-btn-delete" @click="goDel(scope.row.id)">
                  删除
                </div>
              </div>
            </template>
          </table-people>
        </div>
      </div>
    </div>
    <popup title="提示" :show.sync="show" :content="popupContent" confirm-button-text="确 定" background="#FF645F" @toTrue="toTrue" />
  </div>
</template>

<script>
import SimpleSearch from '@/components/search/SimpleSearch'
import TablePeople from '@/components/table/TablePeople'
import Popup from '@/components/popup/Popup'
import ThirdRouterNav from '@/components/dashboard/ThirdRouterNav'
import { goldenIdeaPage, sysCompanyPage, deleteGoldenIdea, goldenIdeaGetClassify, goldenIdEaexportExcel, getLoginInfo } from '@/api/index'
export default {
  components: {
    SimpleSearch,
    TablePeople,
    Popup,
    ThirdRouterNav
  },
  data() {
    return {
      loading: false,
      searchData: [
        { name: '用户姓名', field: 'createByName', type: 'text' },
        { name: '用户所属公司', field: 'companyIdList', type: 'select', hide: false,
          props: { multiple: true, collapseTags: true, filterable: true },
          options: []
        },
        { name: '金点子分类', field: 'classifyId', type: 'select',
          props: { multiple: false, collapseTags: false, filterable: false },
          options: []
        },
        { name: '发布标题', field: 'keywords', type: 'text' },
        { name: '发布状态', field: 'publishStatus', type: 'select',
          props: { multiple: false, collapseTags: false, filterable: false },
          options: [
            { label: '已发布', value: '2' },
            { label: '未发布', value: '1' }
          ]
        }
      ],
      size: 10,
      current: 1,
      total: 0,
      tableHeaders: [
        { prop: 'createByInfo', label: '用户姓名', options: [{ type: 'sort' }] },
        { prop: 'companyList', label: '用户所属公司', options: [{ type: 'sort' }] },
        { prop: 'classifyIdInfo', label: '金点子分类', options: [{ type: 'sort' }] },
        { prop: 'ideaTitle', label: '发布标题', options: [{ type: 'sort' }] },
        { prop: 'email', label: '邮箱', options: [{ type: 'sort' }] },
        { prop: 'publishStatus', label: '发布状态', options: [{ type: 'sort' }] },
        { prop: 'publishTime', label: '发布时间', options: [{ type: 'sort' }] },
        { prop: 'options', label: '操作', width: 200 }
      ],
      tableData: [],
      show: false,
      popupContent: '',
      searchParams: {},
      id: ''
    }
  },
  mounted() {
    this.getGoldenIdeaGetClassify()
    this.getLoginInfoData()
    this.getGoldenIdeaPage()
  },
  methods: {
    getLoginInfoData() {
      getLoginInfo().then((res) => {
        if (res.data.role.indexOf(1) !== -1) {
          this.getSysCompanyPage()
        } else {
          this.searchData[1].hide = true
        }
      })
    },
    getSysCompanyPage() {
      const data = {
        current: 1,
        size: 9999
      }
      sysCompanyPage(data).then((res) => {
        this.searchData[1].options = res.data.records.map(item => {
          return { label: item.companyName, value: item.id }
        })
      })
    },
    getGoldenIdeaPage() {
      this.loading = true
      const data = {
        current: this.current,
        size: this.size,
        ...this.searchParams
      }
      goldenIdeaPage(data).then((res) => {
        this.loading = false
        if (res.code === 0) {
          this.total = res.data.total
          this.tableData = res.data.records
        }
        // 在删除时候判断
        if (this.total > 0 && this.current > 1 && this.tableData.length === 0) {
          this.current -= 1
          this.getGoldenIdeaPage()
        }
      }).finally(result => {
        this.loading = false
      })
    },
    /**
     * 删除接口
     * */
    getDeleteGoldenIdea() {
      deleteGoldenIdea(this.id).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getGoldenIdeaPage()
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    /**
     * 金点子分类
     */
    getGoldenIdeaGetClassify() {
      goldenIdeaGetClassify().then((res) => {
        this.searchData[2].options = res.data.map(item => {
          return { label: item.classifyName, value: item.id }
        })
      })
    },
    // 查询
    getSearch(data) {
      this.current = 1
      this.size = 10
      const param = {}
      Object.keys(data).map(key => {
        data[key] && (param[key] = data[key])
      })
      this.searchParams = param
      console.log(this.searchParams)
      this.getGoldenIdeaPage()
    },
    // 重置
    getReset() {
      this.current = 1
      this.size = 10
      this.searchParams = {}
      this.getGoldenIdeaPage()
    },
    // 分页页数改变
    currentPage(page) {
      this.current = page
      this.getGoldenIdeaPage()
    },
    /**
       * 分页大小改变
       * */
    sizeChange(size) {
      this.size = size
      this.getGoldenIdeaPage()
    },
    // 详情
    goDetail(id) {
      this.$router.push({
        path: `/goldenIdeas/detail`,
        query: { id }
      })
    },
    // 编辑
    goEdit(id) {
      console.log(id)
    },
    // 停用
    goDisable(id) {
      this.popupContent = id === 0 ? '用户将停止访问丹纳赫医学诊断平台移动端<br /><br />请确认是否停用？' : '用户将启用访问丹纳赫医学诊断平台移动端<br /><br />请确认是否启用？'
      this.show = true
      console.log(id)
    },
    // 删除
    goDel(id) {
      this.popupContent = '是否删除？'
      this.show = true
      this.id = id
    },
    // 点击确定弹窗
    toTrue() {
      this.show = false
      this.getDeleteGoldenIdea()
    },
    /**
     * 下载
     */
    getGoldenIdEaexportExcel() {
      const data = {
        ...this.searchParams
      }
      goldenIdEaexportExcel(data).then((res) => {
        if (!res) { return false }
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(res)
        link.download = `金点子列表.xlsx`
        link.click()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .group-management-container {
    background-color: #fff;
    width: 100%;
    flex: 1;
    .menu-router-container {
      display: flex;
      justify-content: space-between;
      background-color: #ebeeef;
      .simple-menu-right {
        width: 200px;
        margin-right: 40px;
        display: flex;
        justify-content: flex-end;
        .el-button {
          height: 32px;
          line-height: 32px;
          padding: 0 10px;
          margin-left: 15px;
        }
      }
    }
    .menu-stores {
      padding: 20px;
      .simple-menu-box {
        display: flex;
        justify-content: space-between;
        background-color: #f7f9fb;
        padding-right: 20px;
        ::v-deep .el-button {
          height: 32px;
          line-height: 32px;
          padding: 0 12px;
          margin-top: 24px;
        }
      }
    }
    .user-table {
      width: 100%;
      margin-top: 30px;
      .disable-btn {
        color: #999999;
      }
      .edit-btn {
        color: #E6A23C;
      }
      .del-btn {
        color: #FF3939;
      }
    }
  }
</style>
